/** General page destinations shared by the public and customer headers. */
export const PUBLIC_NAVIGATION_DESTINATIONS = [
  { id: 'home', labelKey: 'public.navigation.home', icon: 'i-lucide-house', path: '/' },
  { id: 'events', labelKey: 'public.navigation.events', icon: 'i-lucide-ticket', path: '/events' }
] as const
